
 import * as React from 'react';
 import {createComponent, EventName} from '@lit/react';
 
 import {ObcAccordionItem as ObcAccordionItemElement} from '@oicl/openbridge-webcomponents/dist/components/accordion-item/accordion-item.js';
 
 
 

 
 export const ObcAccordionItem = createComponent({
   react: React,
   tagName: 'obc-accordion-item',
   elementClass: ObcAccordionItemElement,
   events: {
     
     onAccordionItemToggle: 'accordion-item-toggle' as EventName<CustomEvent<{open: boolean, title: string}>>,
   }
  });
 
 